import { render, staticRenderFns } from "./rescheduleIndex.vue?vue&type=template&id=0c6b0254&scoped=true&"
import script from "./rescheduleIndex.vue?vue&type=script&lang=js&"
export * from "./rescheduleIndex.vue?vue&type=script&lang=js&"
import style0 from "./rescheduleIndex.vue?vue&type=style&index=0&id=0c6b0254&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6b0254",
  null
  
)

export default component.exports